import { timeAgo } from "../utils/time";
import "./UpdatedAt.css";
import { MaterialSymbol } from "./MaterialSymbol";
import { HStack } from "./Stack";
import { TextMono } from "./typography/TextMono";

/**
 * Displays relative time since last update with icon.
 *
 * [Design System →](http://localhost:5174/component/Data%20Display)
 */
export const UpdatedAt = (props: { updatedAt: string }) => {
	return (
		<time dateTime={props.updatedAt} class="gvtui-item-updated-at">
			{props.updatedAt && (
				<HStack spacing="small" align="center">
					<MaterialSymbol symbol="timelapse" color="fg4" />
					<TextMono color="fg4" size="body">
						{timeAgo(props.updatedAt as string)}
					</TextMono>
				</HStack>
			)}
		</time>
	);
};
